import { Noticia } from './../../shared/dtos/noticia';
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component({
    components: {

    },
})
export default class NoticiasComponente extends Vue {
    @Prop() public noticia!: Noticia;
    @Prop() public mancheta!: boolean;
    @Prop() public contenido!: boolean;

    public get fecha() {
        if(this.noticia.fechaDePublicacion != undefined)
            return  this.noticia.fechaDePublicacion.toString().substring(0,10) + "   " + this.noticia.fechaDePublicacion.toString().substring(12,19);
    }

    public back() {
        this.$router.back();
    }
}
